<template>
  <v-row no-gutters>
    <v-col style="border-right: 1px solid #eee;">
      <v-list dense class="pt-0" width="240px">
        <v-subheader>Structure</v-subheader>

        <template v-for="type in cardTypes.filter(c => c.type == 'page')">
          <v-list-item
            v-if="type.type != 'divider'"
            @click="$emit('pickIcon', type.value)"
            :key="type.value"
            ref="listItem"
          >
            <v-list-item-icon>
              <oh-v-icon
                :name="type.icon"
                :class="type.color"
                :style="type.style ? type.style : ''"
              ></oh-v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ type.label }}</v-list-item-title>
            <v-list-item-title style="max-width: 51px;">
              <template v-for="(key, index) in type.md">
                <kbd :key="index">{{ key }}</kbd>
                <span v-if="index < type.md.length - 1" :key="index + 'space'"> + </span>
              </template>
            </v-list-item-title>
          </v-list-item>
          <template v-else>
            <v-divider :key="type.label + 'divider'"></v-divider>
            <v-subheader :key="type.label">{{ type.label }}</v-subheader>
          </template>
        </template>
      </v-list>
      <v-divider></v-divider>
      <v-list dense class="pt-0">
        <template v-for="type in cardTypes.filter(c => c.type == 'group')">
          <v-list-item
            v-if="type.type != 'divider'"
            @click="$emit('pickIcon', type.value)"
            :key="type.value"
            ref="listItem"
          >
            <v-list-item-icon>
              <oh-v-icon
                :name="type.icon"
                :class="type.color"
                :style="type.style ? type.style : ''"
              ></oh-v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ type.label }}</v-list-item-title>
            <v-list-item-title style="max-width: 51px;">
              <template v-for="(key, index) in type.md">
                <kbd :key="index">{{ key }}</kbd>
                <span v-if="index < type.md.length - 1" :key="index + 'space'"> + </span>
              </template>
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-col>
    <v-col style="border-right: 1px solid #eee;">
      <v-list dense class="pt-0" width="200">
        <v-subheader>Cores</v-subheader>
        <template v-for="type in cardTypes.filter(c => c.type == 'action')">
          <v-list-item
            v-if="type.type != 'divider'"
            @click="$emit('pickIcon', type.value)"
            :key="type.value"
            ref="listItem"
          >
            <v-list-item-icon class="mr-6">
              <oh-v-icon
                :class="type.color"
                :style="type.style ? type.style : ''"
                :name="type.icon"
                >{{
              }}</oh-v-icon>
            </v-list-item-icon>
            <v-list-item-title>
              {{ type.label }}
            </v-list-item-title>
            <v-list-item-title>
              <template v-for="(key, index) in type.md">
                <kbd :key="index">{{ key }}</kbd>
                <span v-if="index < type.md.length - 1" :key="index + 'space'"> + </span>
              </template>
            </v-list-item-title>
          </v-list-item>
          <template v-else>
            <v-divider :key="type.label + 'divider'"></v-divider>
            <v-subheader :key="type.label">{{ type.label }}</v-subheader>
          </template>
        </template>
      </v-list>
    </v-col>
    <v-col>
      <v-list dense class="pt-0" width="200">
        <v-subheader>Information</v-subheader>
        <template v-for="type in cardTypes.filter(c => c.type == 'info')">
          <v-list-item
            v-if="type.type != 'divider'"
            @click="$emit('pickIcon', type.value)"
            :key="type.value"
            ref="listItem"
          >
            <v-list-item-icon class="mr-6">
              <oh-v-icon
                :name="type.icon"
                :color="type.color"
                :style="type.style ? type.style : ''"
              ></oh-v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ type.label }}</v-list-item-title>
            <v-list-item-title>
              <template v-for="(key, index) in type.md">
                <kbd :key="index">{{ key }}</kbd>
                <span v-if="index < type.md.length - 1" :key="index + 'space'"> + </span>
              </template>
            </v-list-item-title>
          </v-list-item>
          <template v-else>
            <v-divider :key="type.label + 'divider'"></v-divider>
            <v-subheader :key="type.label">{{ type.label }}</v-subheader>
          </template>
        </template>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
import cardTypes from './cardTypes';

export default {
  data() {
    return {
      cardTypes
    };
  }
};
</script>

<style></style>
